import { Box, Typography } from '@mui/material';
import { SettingsInputProps } from './SettingsInput/SettingsInputProps';
import { SettingsValueType } from '../../interfaces/Settings/SettingsValueType';
import { TextSettingsInput } from './SettingsInput/TextSettingsInput';
import { sharedStyles } from '../../utils/Style';
import { BooleanSettingsInput } from './SettingsInput/BooleanSettingsInput';
import { ColorSettingsInput } from './SettingsInput/ColorSettingsInput';
import { NumberSettingsInput } from './SettingsInput/NumberSettingsInput';
import { SelectSettingsInput } from './SettingsInput/SelectSettingsInput';
import { MultiSelectSettingsInput } from './SettingsInput/MultiSelectSettingsInput';

interface SettingsRowProps extends SettingsInputProps {
  name: string;
  valueType: SettingsValueType;
}

const getInputCmp = (valueType: SettingsValueType) => {
  switch (valueType) {
    case SettingsValueType.BOOLEAN:
      return BooleanSettingsInput;
    case SettingsValueType.COLOR:
      return ColorSettingsInput;
    case SettingsValueType.NUMBER:
      return NumberSettingsInput;
    case SettingsValueType.SELECT:
      return SelectSettingsInput;
    case SettingsValueType.MULTISELECT:
      return MultiSelectSettingsInput;
    default:
      return TextSettingsInput;
  }
};

export const SettingsRow = (props: SettingsRowProps) => {
  const Cmp = getInputCmp(props.valueType);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Typography
        sx={{
          ...sharedStyles.subtitle1,
          fontWeight: 500,
          width: 200,
          minWidth: 200,
        }}
      >
        {props.name}
      </Typography>
      <Cmp {...props} />
    </Box>
  );
};
